import { Button } from '@cian/ui-kit';
import * as React from 'react';

interface IBrokerButtonProps {
  loading: boolean;
  onClick: () => void;
}

export const BrokerButton: React.FC<IBrokerButtonProps> = ({ loading, onClick }) => {
  return (
    <Button loading={loading} size="XS" theme="fill_success_primary" onClick={onClick}>
      Провести сделку
    </Button>
  );
};
